import { Pipe, PipeTransform } from '@angular/core';
import {PlayerSideUIChoices} from '../../../features/profile/enums/player-side.enum';

@Pipe({
  name: 'playingSide'
})
export class PlayingSidePipe implements PipeTransform {

  transform(sideFlags: boolean[] ): string {
    const labels = [];
    if (sideFlags.length === 3) {
      if (sideFlags[0]) {
        labels.push(PlayerSideUIChoices.left);
      }
      if (sideFlags[1]) {
        labels.push(PlayerSideUIChoices.centre);
      }
      if (sideFlags[2]) {
        labels.push(PlayerSideUIChoices.right);
      }
      if (labels.length > 0) {
        return labels.join(', ');
      }
      return 'Not Specified';
    }
  }
}
